import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";


export default function ProductFilter({ filterProducts }) {
    const navigate = useNavigate()

    const [form, setForm] = useState({
        filterText: "",
        supplierId: "",
        type: ""
    });
    const [suppliers, setSuppliers] = useState([]);
    const { user } = useAuthContext();
    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    function submitClicked() {
        filterProducts(form);
    }

    useEffect(() => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSuppliers(res.data);
                }
            })
    }, [])


    return (
        <div className="filterBox">
            <div className="row">
                <div className="col-12">
                <h5>Filter Options</h5>
                </div>
            </div>
            

            <div className="row">
                { /* Filter Text */}
                <div className="form-group col-3">
                    <label>Filter Text</label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="e.g cattle feed"
                        onChange={(e) => setField("filterText", e.target.value)}

                    />
                </div>

                { /* Supplier */}
                <div className="form-group col-3">
                    <label>Supplier</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("supplierId", e.target.value)}
                            value={form && form.supplierId}
                        >
                            <option value="">All Suppliers</option>
                            {suppliers && (suppliers.map((supplier) => {
                                return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                            }))}
                        </Form.Select>
                    </div>
                </div>
                { /* Type */}
                <div className="form-group col-3">
                    <label>Type</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("type", e.target.value)}
                            value={form && form.type}
                        >
                            <option value="">All Types</option>
                            <option>Additives</option>
                            <option>Blend</option>
                            <option>Buffers</option>
                            <option>Caustic Wheat</option>
                            <option>Compound</option>
                            <option>Fat</option>
                            <option>Grass Seeds</option>
                            <option>Milk Powder</option>
                            <option>Minerals</option>
                            <option>Moist Feed</option>
                            <option>Molases</option>
                            <option>Yeast</option>
                        </Form.Select>
                    </div>
                </div>
            
                <div className="col-2">
                    <br/>
                    <button className="btn btn-primary" onClick={submitClicked}>Filter</button>
                </div>
            </div>
        </div>
    )
}
